import HttpClient from '@/common/lib/http-client'
import { BaseResponse } from '@/common/models/responses/base'
import { ChatMessage, IChatMessage } from '@/common/models/data/dashboard/chat/chat-message'
import { IPaginatedResponse, PaginatedResponse } from '@/common/models/data/common/pagination/paginated-response'

import { chat as Api } from '@/app/api'

class ChatRepository {
    async paginated (page: number): Promise<PaginatedResponse<ChatMessage>> {
        const response = await HttpClient.getJson<IPaginatedResponse<IChatMessage>>(Api.messages(page))

        return PaginatedResponse.fromInterface(response, (message): ChatMessage => {
            return new ChatMessage(message)
        })
    }

    async pages (lastPage: number): Promise<Array<ChatMessage>> {
        const response = await HttpClient.getJson<Array<ChatMessage>>(Api.pages(lastPage))

        return response.map(message => new ChatMessage(message))
    }

    async create (data: Pick<IChatMessage, 'author' | 'content'>): Promise<boolean> {
        const response = await HttpClient.postJson<BaseResponse>(Api.store, data)

        return response.status === 'success'
    }
}

export default new ChatRepository()
